module.exports = __webpack_public_path__ + "static/img/avatar-w600.d26f97c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar-w600.jpg
// module id = ArjM
// module chunks = 1